import { useState, useEffect } from 'react';
import { Sort } from 'src/icons/Sort.icon';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Menu, Select } from 'antd';
import {
  ActionMenuIcon,
  BinIcon,
  EditAppointmentIcon,
  PlusIcon,
} from 'src/icons';
import { SuperAdminTable } from '../../../../baseComponents/Table';
import { Button } from '../../../../baseComponents';
import {
  getQuestionnairesAction,
  getQuestionnaireByIdAction,
} from '../../../../../store/actions/questionnaire.action';
import { getConditionListAction } from 'src/modules/SuperAdmin/store/actions/condition.action';
import AddNewQuestionnaire from './AddNewQuestionnaire';
import EditQuestionnaire from './EditQuestionnaire';
import DeleteQuestionnaire from './DeleteQuestionnaire';

export const QuestionnairePage = () => {
  const { questionnaireList, loading } = useSelector(
    (state) => state?.questionnaireState
  );
  const { getAllConditionsList } = useSelector(
    (state) => state?.conditionState
  );
  const [tableData, setTableData] = useState(null);
  const [questionnaireModalOpen, setQuestionnaireModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [isfilterOn, setIsFilterOn] = useState(false);
  const [conditionOptions, setConditionOptions] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getQuestionnairesAction());
    dispatch(getConditionListAction());
  }, [dispatch]);

  useEffect(() => {
    setTableLoader(loading);
  }, [loading]);

  useEffect(() => {
    if (
      questionnaireList &&
      Array.isArray(questionnaireList) &&
      questionnaireList.length > 0
    ) {
      let dataArray = questionnaireList?.map((list, index) => {
        return {
          key: index,
          questionnaire_id: list?.questionnaire_id,
          condition_id: list?.condition_id,
          condition_name: list?.condition_name,
          questions: list?.questions,
        };
      });
      if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
        setTableData(dataArray);
      }
    } else {
      setTableData([]);
    }
  }, [questionnaireList]);

  useEffect(() => {
    if (
      getAllConditionsList &&
      Array.isArray(getAllConditionsList) &&
      getAllConditionsList.length > 0
    ) {
      setConditionOptions([
        { label: 'All', value: 'All' },
        ...getAllConditionsList.map((condition) => ({
          label: condition.condition_name,
          value: condition.condition_id,
        })),
      ]);
    }
  }, [getAllConditionsList]);

  const handleEditQuestionnaire = (questionnaireId) => {
    dispatch(
      getQuestionnaireByIdAction(questionnaireId, () => setEditModalOpen(true))
    );
  };

  const handleDeleteQuestionnaire = (questionnaireId) => {
    dispatch(
      getQuestionnaireByIdAction(questionnaireId, () =>
        setDeleteModalOpen(true)
      )
    );
  };

  const menuOptions = (id, record) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editQuestionnaire') {
            handleEditQuestionnaire(id, record);
          }

          if (key === 'deleteQuestionnaire') {
            handleDeleteQuestionnaire(id, record);
          }
        }}
      >
        <Menu.Item key="editQuestionnaire">
          <div className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit questionnaire</span>
          </div>
        </Menu.Item>
        <Menu.Item key="deleteQuestionnaire">
          <div className="dropdown-text flex items-center space-x-2">
            <BinIcon /> <span>Remove questionnaire</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const conditionNameSorter = (a, b) => {
    return a.condition_name.localeCompare(b.condition_name);
  };

  const columns = [
    {
      title: (
        <span className="font-[700]">
          {' '}
          Condition name{' '}
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'condition_name',
      key: 'condition_name',
      sorter: tableData?.length > 0 && conditionNameSorter,
    },
    {
      title: <span className="font-[700]"> Questions </span>,
      dataIndex: 'questions',
      key: 'questions',
      render: (questions) => {
        if (!questions) return 'No questions';

        // Since questions is a string, truncate it for preview
        const maxLength = 50; // Adjust this value to control preview length
        return questions.length > maxLength
          ? `${questions.substring(0, maxLength)}...`
          : questions;
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <Dropdown
            className=""
            overlay={menuOptions(record?.questionnaire_id, record)}
          >
            <a className="" onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const initialFilterValue = {
    condition_id: null,
  };

  const [filterValue, setFilterValue] = useState(initialFilterValue);

  const filterHandler = (type, value) => {
    if (type === 'condition') {
      if (value === 'All') {
        setFilterValue({
          ...filterValue,
          condition_id: null,
        });
        setIsFilterOn(false);
        dispatch(getQuestionnairesAction());
      } else {
        setFilterValue({
          ...filterValue,
          condition_id: value,
        });
        setIsFilterOn(true);
        dispatch(getQuestionnairesAction(value));
      }
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row lg:justify-between justify-center items-center">
        <div className="flex flex-col sm:flex-row">
          <div className="flex justify-start gap-12 ">
            <div className="bg-white shadow-sm rounded-xl w-60 flex items-center">
              <Select
                style={{
                  placeholder: {
                    fontFamily: 'Poppins',
                    color: '#667085',
                  },
                }}
                bordered={false}
                className="border-none font-sans h-10 flex items-center focus:outline-none w-full"
                optionFilterProp="label"
                placeholder="Search condition"
                showSearch
                options={conditionOptions}
                onChange={(e) => filterHandler('condition', e)}
                value={filterValue.condition_id}
                id="Condition_Id"
              ></Select>
            </div>
          </div>
        </div>
        <div className="flex justify-end items-end">
          <Button
            type={'button'}
            onClick={() => {
              setQuestionnaireModalOpen(true);
            }}
          >
            <PlusIcon className={`mr-2`} /> Add questionnaire
          </Button>
        </div>
      </div>
      <div>
        <div className="mt-5 ant-table rounded-xl shadow-xl">
          <SuperAdminTable
            className={'appointment-page-table'}
            data={tableData}
            columns={columns}
            loading={tableLoader}
          />
        </div>
      </div>

      {/* All modals constructed here */}
      <AddNewQuestionnaire
        isOpen={questionnaireModalOpen}
        setIsOpen={setQuestionnaireModalOpen}
        isfilterOn={isfilterOn}
        filterValue={filterValue}
      />

      <EditQuestionnaire
        isOpen={editModalOpen}
        setIsOpen={setEditModalOpen}
        isfilterOn={isfilterOn}
        filterValue={filterValue}
      />

      <DeleteQuestionnaire
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        isfilterOn={isfilterOn}
        filterValue={filterValue}
      />
    </div>
  );
};

export default QuestionnairePage;
